import React, { useEffect, useState } from 'react';
import CrudTable from '../../components/common/CrudTable';
import { gymAPI, sportTypeAPI, trainingSchoolAPI } from '../../api/services';

const BranchesAdmin = () => {
  const [sportTypes, setSportTypes] = useState([]);
  const [trainingSchools, setTrainingSchools] = useState([]);

  useEffect(() => {
    sportTypeAPI.getAll().then(res => setSportTypes(res.data?.data || [])).catch(() => {});
    trainingSchoolAPI.getAll().then(res => setTrainingSchools(res.data?.data || [])).catch(() => {});
  }, []);

  const COLUMNS = [
    { key: 'name', label: 'Name' },
    { key: 'trainingSchoolName', label: 'Training School' },
    { key: 'sportTypeName', label: 'Sport Type' },
    { key: 'location', label: 'Location' },
    { key: 'mediaUrl', label: 'Image', render: (item) => item.mediaUrl ? <img src={item.mediaUrl} alt="" style={{ width: 48, height: 32, objectFit: 'cover', borderRadius: 6 }} /> : '—' },
  ];

  const FORM_FIELDS = [
    { name: 'name', label: 'Branch Name', placeholder: 'Champion Branch' },
    { 
      name: 'trainingSchoolId', 
      label: 'Training School', 
      type: 'select', 
      options: trainingSchools.map(s => ({ label: s.name, value: s.id })) 
    },
    { name: 'location', label: 'Location', placeholder: 'Tashkent' },
    { name: 'mapLink', label: 'Map Link', placeholder: 'https://maps.google.com/...' },
    { 
      name: 'sportTypeId', 
      label: 'Sport Type', 
      type: 'select', 
      options: sportTypes.map(s => ({ label: s.name, value: s.id })) 
    },
    { name: 'mediaId', label: 'Branch Image', type: 'file' },
  ];

  return (
    <CrudTable
      title="Branches"
      entityName="Branch"
      columns={COLUMNS}
      formFields={FORM_FIELDS}
      fetchData={async () => {
        const res = await gymAPI.getAll();
        return res.data?.data || [];
      }}
      onAdd={(data) => gymAPI.add(data)}
      onUpdate={(id, data) => gymAPI.update(id, data)}
      onDelete={(id) => gymAPI.delete(id)}
    />
  );
};

export default BranchesAdmin;
